module.exports = __webpack_public_path__ + "img/textSmall.57fc0a0f.svg";